import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ClubConnect — Firebase config (project: clubconnect-b7af5)
// The apiKey below is a public client identifier, not a secret — it is safe to
// ship in the bundle. Access control is enforced via Firestore/Storage
// Security Rules (see firestore.rules / storage.rules in this repo), not by
// hiding this value.
const firebaseConfig = {
  apiKey: "AIzaSyCPFwhORA3_dgHKH1dLc2Ne0LqwFkC7C78",
  authDomain: "clubconnect-b7af5.firebaseapp.com",
  projectId: "clubconnect-b7af5",
  storageBucket: "clubconnect-b7af5.firebasestorage.app",
  messagingSenderId: "332939387146",
  appId: "1:332939387146:web:7e42d7b3087b80ed599af3",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// WebKit/Safari's fetch implementation doesn't support the streaming
// responses Firestore's default channel relies on, which surfaces as
// "Fetch API cannot load ... due to access control checks" in the console.
// Auto-detection still tries fetch-streaming first and only falls back
// after that failure, so the error still logs once; forcing long-polling
// (XHR-based, no streaming) skips the broken code path entirely.
export const db = initializeFirestore(app, { experimentalForceLongPolling: true });
export const storage = getStorage(app);
